import {
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import saveFilledIcon from "../../assets/img/save_filled_icon.svg";
import { useTranslation } from "react-i18next";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import WorkIcon from "@mui/icons-material/Work";
import LanguageIcon from "@mui/icons-material/Language";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import warning_logo from "../../assets/img/warning_icon.svg";
import coin_icon from "../../assets/img/coin_icon.svg";
import target_icon from "../../assets/img/target_icon.svg";
import mode_icon from "../../assets/img/mode_icon.svg";
import { styled } from "@mui/system";
import logo from "../../assets/img/new_logo.svg";
import saveIcon from "../../assets/img/save_icon.svg";
import { useNavigate } from "react-router-dom";
import useUserId from "hooks/useUserId";
import colors from "colors/color";
import expired_icon from "../../assets/img/expired_icon.svg";
import { useSaveStatus } from "views/Offers/hooks/useSavePost";
import { calculateTimeSincePosting } from "views/Offers/Details";
import smart_logo_white from "../../assets/img/smart_logo_white.svg";
import smart_logo from "../../assets/img/small_logo.svg";
import mail_logo from "../../assets/img/mail_icon.svg";
import mail_logo_white from "../../assets/img/email_logo_white.svg";

const JobCardContainer = styled(Card)(({ theme }) => ({
  border: "1px solid #F0F0F0",
  backgroundColor: "#FFFFFF",
  padding: theme.spacing(3),
  borderRadius: 20,
  // minWidth: "100%",
  maxWidth: 450,
  position: "relative",
  flex: "0 0 auto",
  minHeight: 271,
  maxHeight: "max-content",
  display: "flex",
  flexDirection: "column",
  boxShadow: "none",
  cursor: "default",
  transition: "all 0.8s ease",
  "&:hover": {
    boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
    borderColor: "#0017E7",
    transition: "all 0.3s ease",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    minHeight: "auto",
  },
}));

const SelectButton = styled(Box)(({ theme, isselected }) => ({
  position: "absolute",
  top: 16,
  right: 16,
  width: 32,
  height: 32,
  borderRadius: "10px",
  backgroundColor: isselected === "true" ? "#0017E7" : "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
  zIndex: 10,
  border: isselected === "true" ? "1.5px solid #0017E7" : "1.5px solid #E8E8E8",
  boxShadow: isselected === "true"
    ? "0px 4px 12px rgba(0, 23, 231, 0.25)"
    : "0px 2px 8px rgba(0, 0, 0, 0.08)",
  "&:hover": {
    backgroundColor: isselected === "true" ? "#0012B8" : "#F8F9FF",
    borderColor: "#0017E7",
    transform: "scale(1.05)",
    boxShadow: isselected === "true"
      ? "0px 6px 16px rgba(0, 23, 231, 0.35)"
      : "0px 4px 12px rgba(0, 23, 231, 0.15)",
  },
  "&:active": {
    transform: "scale(0.95)",
  },
  [theme.breakpoints.down("sm")]: {
    width: 28,
    height: 28,
    top: 12,
    right: 12,
    borderRadius: "8px",
  },
}));

const CompanyLogo = styled(Box)(({ theme, logo }) => ({
  minWidth: "59px",
  minHeight: "59px",
  maxWidth: "59px",
  maxHeight: "59px",
  background:
    "linear-gradient(135deg, rgba(0, 23, 231, 0.5) -54.69%, rgba(255, 204, 248, 0.5) 66.41%)",
  borderRadius: 14,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "0.75rem",
  textAlign: "center",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    minWidth: "45px",
    minHeight: "45px",
    maxWidth: "45px",
    maxHeight: "45px",
    borderRadius: 10,
  },
}));

const ExpiryChip = styled(Box)(({ theme }) => ({
  backgroundColor: "#FBBC0533",
  color: "#FBBC05",
  padding: "5px 15px 5px 15px",
  borderRadius: "8px",
  fontSize: "8px",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  border: "0.3px solid #FBBC05",
  minWidth: "120px",
  justifyContent: "center",
  whiteSpace: "nowrap",
  maxHeight: 25,
  [theme.breakpoints.down("sm")]: {
    minWidth: "auto",
    padding: "4px 8px",
    fontSize: "7px",
  },
}));

const DetailItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  fontSize: "12px",
  fontWeight: 500,
  fontFamily: "Poppins",
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
    gap: theme.spacing(0.5),
  },
}));

const SaveButton = styled(Button)(
  ({ theme, variant, issaved, fromSavedPosts }) => ({
    maxWidth: "100%",
    width: "100%",
    height: 44,
    borderRadius: "11px",
    borderWidth: "1px",
    border: "1px solid #0017E7",
    color: "#0017E7",
    backgroundColor: issaved === "true" ? "#0017E7" : "transparent",
    "&:hover": {
      backgroundColor:
        issaved === "true" ? "#0017E7" : "rgba(61, 90, 254, 0.04)",
      borderColor: "#3D5AFE",
    },
    padding: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      height: 38,
      borderRadius: "8px",
    },
  })
);

const ActionButton = styled(Button)(({ theme, variant }) => ({
  borderRadius: 11,
  padding: theme.spacing("12px", "10px", "12px", "10px"),
  textTransform: "none",
  fontWeight: 400,
  fontFamily: "Poppins",
  border: variant === "outlined" ? "1px solid #0017E7" : "none",
  color: variant === "outlined" ? "#0017E7" : "#fff",
  backgroundColor: variant === "outlined" ? "transparent" : "#0017E7",
  "&:hover": {
    backgroundColor:
      variant === "outlined" ? "rgba(61, 90, 254, 0.04)" : "#0017E7",
    borderColor: variant === "outlined" ? "#3D5AFE" : "none",
  },
  width: "auto",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing("8px", "16px"),
    fontSize: "12px",
    borderRadius: 8,
    whiteSpace: "nowrap",
  },
  [theme.breakpoints.down("xs")]: {
    padding: theme.spacing("6px", "12px"),
    fontSize: "11px",
  },
}));

const TruncatedTypography = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  display: "block",
  marginLeft: 6.2,
});

export default function JobCard({
  job,
  setSelectedJob,
  setOpenDialog,
  refresh,
  spontaneous,
  fromSavedPosts,
  isSelected,
  onToggleSelect,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXS = useMediaQuery(theme.breakpoints.down("xs"));
  const navigate = useNavigate();
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "info",
    action: null,
  });
  const user = useUserId();
  const userId = user.userId;
  const { t } = useTranslation();
  
  useEffect(()=>{
    console.log('job=:', job)
  },[job])
  
  const jobId = job?.id || "";
  const isSpontaneousApp = job?.isSpontaneous || spontaneous;

  // Use job.isSaved as initial state if it exists
  const [jobIsSaved, setJobIsSaved] = useState(job?.isSaved || false);

  // useEffect(()=>{
  //   console.log('job=:', job)
  // },[job])
  const { isLoading, error, toggleSaveStatus, isSaved } = useSaveStatus({
    jobId,
    initialSaved: job?.isSaved,
    type: isSpontaneousApp ? "spontaneous" : "post",
    onSaveChange: (newStatus) => {
      if (job) {
        setJobIsSaved(newStatus);
        console.log(
          `${isSpontaneousApp ? "Spontaneous application" : "Job"
          } ${jobId} is now ${newStatus ? "saved" : "unsaved"}`
        );
        // If we successfully unsaved a post and we're in SavedPosts view, refresh the list
        if (!newStatus && fromSavedPosts && refresh) {
          console.log("Refreshing saved posts after unsave");
          refresh();
        }
      }
    },
  });

  // Use either the job's explicit isSaved property or the value from the hook
  const effectiveIsSaved = job?.isSaved !== undefined ? job.isSaved : isSaved;

  const [deadlineInfo, setDeadlineInfo] = useState({
    color: "#FBBC05", // Default orange
    message: "Days to expire",
    daysRemaining: 0,
    icon: "",
  });

  useEffect(() => {
    const calculateTimeRemaining = () => {
      if (!job.deadline) {
        return {
          color: "#FBBC05",
          message: t("jobCard.deadline.notSet"),
          value: 0,
        };
      }

      let deadlineDate = new Date(job.deadline);
      if (isNaN(deadlineDate.getTime())) {
        return {
          color: "#FBBC05",
          message: t("jobCard.deadline.invalidDate"),
          value: 0,
        };
      }

      const now = new Date();
      const diffMs = deadlineDate - now;
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      const diffMonths = Math.floor(diffDays / 30.44);
      const diffYears = Math.floor(diffDays / 365.25);

      // Expired
      if (diffDays < 0) {
        return {
          color: "#FF0000",
          message: t("jobCard.deadline.expired"),
          value: 0,
          icon: expired_icon,
        };
      }

      // Less than a day
      if (diffDays < 1) {
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        return {
          color: "#FF0000",
          message: t("jobCard.deadline.hoursToExpire", { count: diffHours }),
          value: diffHours,
          icon: warning_logo,
        };
      }

      // Less than a week
      if (diffDays < 7) {
        return {
          color: "#FF0000",
          message: t(
            diffDays === 1
              ? "jobCard.deadline.daysToExpire"
              : "jobCard.deadline.daysToExpire_plural",
            { count: diffDays }
          ),
          value: diffDays,
          icon: warning_logo,
        };
      }

      // Less than a month
      if (diffDays < 30) {
        const weeks = Math.ceil(diffDays / 7);
        return {
          color: colors.primary,
          message: t(
            weeks === 1
              ? "jobCard.deadline.weeksToExpire"
              : "jobCard.deadline.weeksToExpire_plural",
            { count: weeks }
          ),
          value: weeks,
        };
      }

      // Less than a year
      if (diffDays < 365) {
        return {
          color: colors.primary,
          message: t(
            diffMonths === 1
              ? "jobCard.deadline.monthsToExpire"
              : "jobCard.deadline.monthsToExpire_plural",
            { count: diffMonths }
          ),
          value: diffMonths,
        };
      }

      // More than a year
      const remainingMonths = Math.floor((diffDays % 365.25) / 30.44);
      if (remainingMonths > 0) {
        return {
          color: colors.primary,
          message: t(
            diffYears === 1
              ? "jobCard.deadline.yearsAndMonthsToExpire"
              : "jobCard.deadline.yearsAndMonthsToExpire_plural",
            {
              years: diffYears,
              years_plural: diffYears > 1 ? "s" : "",
              months: remainingMonths,
            }
          ),
          value: diffYears,
        };
      }

      return {
        color: colors.primary,
        message: t(
          diffYears === 1
            ? "jobCard.deadline.yearsToExpire"
            : "jobCard.deadline.yearsToExpire_plural",
          { count: diffYears }
        ),
        value: diffYears,
      };
    };

    setDeadlineInfo(calculateTimeRemaining());
  }, [job.deadline]);

  const openDetailsDialog = () => {
    setSelectedJob(job);
    setOpenDialog(true);
  };

  const apiUrl = process.env.REACT_APP_API_URL;

  const getUserResume = async () => {
    if (userId) {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}authentication/get-user-resume/${userId}/`
      );
      const data = await response.json();
      console.log("User resume:", data);
      return data;
    }
    return null;
  };

  const sendMail = async (
    email,
    title,
    description,
    accountType,
    reference
  ) => {
    console.log("Sending mail to:", email);
    console.log("Title:", title);
    console.log("Description:", description);

    // Get user resume data
    const resumeData = await getUserResume();

    let mailtoUrl = "";
    const subject = reference || title;

    // Create a professional email body
    let body = `Dear Recruiter,\n\nI am writing to express my strong interest in the ${title} position${reference ? ` (Reference: ${reference})` : ""
      } at your company.\n\n`;

    // Add resume information if available
    if (resumeData && resumeData.status === "success") {
      // Remove trailing slash from API URL and leading slash from resume_url
      const apiUrl = process.env.REACT_APP_API_URL.replace(/\/$/, "");
      const resumePath = resumeData.resume_url.replace(/^\//, "");
      const resumeUrl = `${apiUrl}/${resumePath}`;

      body += `My Details:\n`;
      body += `- Name: ${resumeData.name}\n`;
      body += `- Resume: ${resumeUrl}\n\n`;
    }

    body += `I came across this opportunity through your job posting and I am very excited about the possibility of joining your team. I believe my skills and experience align well with the requirements of this position.\n\n`;

    body += `Job Details:\n`;
    body += `- Position: ${title}\n`;
    if (reference) body += `- Reference Number: ${reference}\n`;
    if (job.mode) body += `- Work Mode: ${job.mode}\n`;

    body += `\nBest regards,\n`;
    if (resumeData && resumeData.status === "success") {
      body += resumeData.name;
    }

    if (accountType === "m") {
      // Microsoft Outlook
      mailtoUrl = `https://outlook.office.com/mail/deeplink/compose?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}&to=${encodeURIComponent(email)}`;
    } else {
      // Gmail
      mailtoUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        email
      )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }

    window.open(mailtoUrl, "_blank");
  };

  const handleApply = () => {
    localStorage.setItem("job", JSON.stringify(job));
    if (job.scraped) {
      // For scraped jobs, use sendMail
      // sendMail(
      //   job.recruiter_email,
      //   job.title,
      //   job.description,
      //   job.accountType,
      //   job.reference
      // );
      navigate("/fast_application_page", { state: { job } });
    } else if (isSpontaneousApp) {
      // Navigate to spontaneous application page
      navigate("/spontaneous_application_page", {
        state: { spontaneous: job },
      });
    } else {
      // Regular job application
      navigate("/application_page", { state: { job } });
    }
  };

  const handleSaveIconClick = async () => {
    if (effectiveIsSaved) {
      setSnackbarState({
        open: true,
        message: t("myCard.unsaveConfirmation"),
        severity: "warning",
        action: (
          <>
            <Button
              color="primary"
              size="small"
              onClick={() => {
                confirmUnsave();
                setSnackbarState((prev) => ({ ...prev, open: false }));
              }}
              sx={{ color: "#1976d2", mr: 1 }}
            >
              {t("myCard.yes")}
            </Button>
            <Button
              color="secondary"
              size="small"
              onClick={() =>
                setSnackbarState((prev) => ({ ...prev, open: false }))
              }
              sx={{ color: "#666" }}
            >
              {t("myCard.no")}
            </Button>
          </>
        ),
      });
    } else {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await fetch(
          `${apiUrl}candidates/save_post/${userId}/${job.id}/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          setSnackbarState({
            open: true,
            message: t("myCard.postSaved"),
            severity: "success",
            action: null,
          });
          setTimeout(() => {
            setSnackbarState((prev) => ({ ...prev, open: false }));
          }, 2000);
          if (refresh) refresh();
        } else {
          throw new Error(data.error);
        }
      } catch (error) {
        console.error("Error saving the post:", error);
      }
    }
  };

  const confirmUnsave = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${apiUrl}candidates/save_post/${userId}/${job.id}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to unsave post");
      }
      if (refresh) refresh();
      setSnackbarState({
        open: true,
        message: "Post unsaved successfully",
        severity: "success",
        action: null,
      });
      setTimeout(() => {
        setSnackbarState((prev) => ({ ...prev, open: false }));
      }, 2000);
    } catch (error) {
      console.error("Error unsaving the post:", error);
    }
  };

  return (
    <>
      <JobCardContainer
        sx={{
          border: isSelected ? "2px solid #0017E7" : "1px solid #F0F0F0",
          backgroundColor: isSelected ? "#F8F9FF" : "#FFFFFF",
        }}
      >
        {/* Select button for saved posts */}
        {fromSavedPosts === true && spontaneous !== true && (
          <SelectButton
            isselected={isSelected ? "true" : "false"}
            title={isSelected ? "Deselect" : "Select"}
            onClick={(e) => {
              e.stopPropagation();
              if (onToggleSelect && job?.id) {
                onToggleSelect(job.id);
              }
            }}
          >
            {isSelected ? (
              <CheckCircleIcon
                sx={{
                  fontSize: isMobile ? 18 : 20,
                  color: "#FFFFFF",
                }}
              />
            ) : (
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: isMobile ? 18 : 20,
                  color: "#BDBDBD",
                  transition: "color 0.2s ease",
                  ".MuiBox-root:hover &": {
                    color: "#0017E7",
                  },
                }}
              />
            )}
          </SelectButton>
        )}
        <CardContent
          sx={{
            padding: 0,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            "&:last-child": { paddingBottom: 0 },
          }}
        >
          {/* Top content section */}
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: isMobile ? 1 : 2,
                mb: isMobile ? 1.5 : 2,
              }}
            >
              <CompanyLogo logo={job?.cp_logo_url || logo}>
                <img
                  src={job?.cp_logo_url || logo}
                  alt="Company Logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </CompanyLogo>
              <Box sx={{ width: "100%", overflow: "hidden" }}>
                {/* First line: Title and Expiry Chip */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: isMobile ? 0.5 : 1.5,
                    width: "100%",
                    flexWrap: isMobile ? "wrap" : "nowrap",
                    gap: isMobile ? 0.5 : 0,
                    // Add right padding when select button is visible to prevent overlap
                    pr: fromSavedPosts && !spontaneous ? (isMobile ? "36px" : "44px") : 0,
                  }}
                >
                  <TruncatedTypography
                    variant={isMobile ? "subtitle1" : "h6"}
                    sx={{
                      fontWeight: 600,
                      fontSize: isMobile ? "14px" : "16px",
                      fontFamily: "Poppins",
                      textTransform: "none",
                      maxWidth: fromSavedPosts && !spontaneous
                        ? (isMobile ? "100%" : "100%")
                        : (isMobile ? "100%" : "160px"),
                      mb: isMobile ? 0.5 : 0,
                    }}
                  >
                    {isSpontaneousApp
                      ? job.title || job.position || "Spontaneous Application"
                      : job.title || "Job Position"}
                  </TruncatedTypography>
                  {/* Only show ExpiryChip here if NOT from saved posts */}
                  {!(fromSavedPosts && !spontaneous) && (
                    <ExpiryChip color={deadlineInfo.color}>
                      <Box
                        component="img"
                        src={deadlineInfo.icon}
                        sx={{
                          width: isMobile ? 10 : 12,
                          height: isMobile ? 10 : 12,
                          display: "inline-flex",
                          paddingBottom: 0.2,
                        }}
                      />
                      <Typography
                        variant="caption"
                        sx={{ fontSize: isMobile ? "7px" : "8px" }}
                      >
                        {deadlineInfo.message}
                      </Typography>
                    </ExpiryChip>
                  )}
                </Box>

                {/* Second line: Company and Location with full width */}
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    overflow: "hidden",
                    flexWrap: isMobile && isXS ? "wrap" : "nowrap",
                  }}
                >
                  <TruncatedTypography
                    variant="body2"
                    sx={{
                      color: "#000000",
                      fontWeight: 700,
                      fontFamily: "Poppins",
                      fontSize: isMobile ? 9 : 10,
                      flexShrink: 0,
                    }}
                  >
                    {job.cp_name || job.company_name || "Company"}
                  </TruncatedTypography>
                  <TruncatedTypography
                    variant="body2"
                    sx={{
                      color: "#00000080",
                      fontSize: isMobile ? 9 : 10,
                      fontFamily: "Poppins",
                      fontWeight: 300,
                      ml: 0.5,
                      flexGrow: 1,
                    }}
                  >
                    {job.localisation || job.location
                      ? `· ${job.localisation || job.location}`
                      : "· Location"}
                  </TruncatedTypography>
                </Box>
              </Box>
            </Box>

            {/* Job Description - with ellipsis for overflow */}
            <Typography
              variant="body2"
              sx={{
                mb: isMobile ? 1.5 : 2,
                color: "#000000B2",
                fontSize: isMobile ? "11px" : "12px",
                lineHeight: isMobile ? "16px" : "18px",
                fontFamily: "Poppins",
                fontWeight: 400,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: isMobile ? "48px" : "54px",

                // 🔽 Reset HTML tags inside
                "& p": {
                  margin: 0,
                  lineHeight: isMobile ? "16px" : "18px",
                  fontSize: isMobile ? "11px" : "12px",
                  fontWeight: 400,
                  color: "#000000B2",
                },
                "& strong": {
                  fontWeight: 600, // or keep same as your design
                },
              }}
              dangerouslySetInnerHTML={{ __html: job.description }}
            />

            {/* Job Details Row */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: isMobile ? 1 : 2,
                mb: isMobile ? 1.5 : 2,
                justifyContent: "flex-start",
              }}
            >
              <DetailItem sx={{ color: "#0017E7" }}>
                <Box
                  component="img"
                  src={coin_icon}
                  sx={{
                    width: isMobile ? 16 : 20,
                    height: isMobile ? 16 : 20,
                    display: "inline-flex",
                    paddingBottom: 0.2,
                  }}
                />
                <TruncatedTypography sx={{ fontWeight: 500 }}>
                  {job.salary ||
                    job.expected_salary ||
                    t("jobCard.salary.notSpecified")}
                </TruncatedTypography>
                <Typography sx={{ fontSize: isMobile ? "9px" : "inherit" }}>
                  {job.currency || ""}
                </Typography>
                {job.salary ? (
                  <Typography
                    sx={{
                      color: "#00000080",
                      fontWeight: 300,
                      fontSize: isMobile ? "9px" : "inherit",
                    }}
                  >
                    {t("jobCard.salary.perMonth")}
                  </Typography>
                ) : null}
              </DetailItem>

              <DetailItem sx={{ color: "#0017E7" }}>
                <Box
                  component="img"
                  src={target_icon}
                  sx={{
                    width: isMobile ? 16 : 20,
                    height: isMobile ? 16 : 20,
                    display: "inline-flex",
                    paddingBottom: 0.2,
                  }}
                />
                <TruncatedTypography>
                  {isSpontaneousApp
                    ? t("jobCard.jobTypes.spontaneous")
                    : job.jobType === "i"
                      ? t("jobCard.jobTypes.internship")
                      : t("jobCard.jobTypes.job")}
                </TruncatedTypography>
              </DetailItem>

              <DetailItem sx={{ color: "#0017E7" }}>
                <Box
                  component="img"
                  src={mode_icon}
                  sx={{
                    width: isMobile ? 16 : 20,
                    height: isMobile ? 16 : 20,
                    display: "inline-flex",
                    paddingBottom: 0.2,
                  }}
                />
                <TruncatedTypography>
                  {job.mode ||
                    job.work_mode ||
                    t("jobCard.workMode.notSpecified")}
                </TruncatedTypography>
              </DetailItem>

              {/* Show ExpiryChip here for saved posts cards */}
              {fromSavedPosts && !spontaneous && (
                <ExpiryChip color={deadlineInfo.color}>
                  <Box
                    component="img"
                    src={deadlineInfo.icon}
                    sx={{
                      width: isMobile ? 10 : 12,
                      height: isMobile ? 10 : 12,
                      display: "inline-flex",
                      paddingBottom: 0.2,
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ fontSize: isMobile ? "7px" : "8px" }}
                  >
                    {deadlineInfo.message}
                  </Typography>
                </ExpiryChip>
              )}
            </Box>
          </Box>

          {/* Action Buttons - placed at the bottom with responsive layout */}
          <Box sx={{ mt: "auto" }}>
            {/* On mobile view */}
            {isMobile && (
              <>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  {userId && user.role === "c" && (
                    <Grid item xs={12}>
                      <SaveButton
                        variant="outlined"
                        issaved={effectiveIsSaved ? "true" : "false"}
                        onClick={toggleSaveStatus}
                        fromSavedPosts={fromSavedPosts}
                        sx={{ mb: 1 }}
                      >
                        <img
                          src={
                            effectiveIsSaved ||
                              fromSavedPosts === true ||
                              fromSavedPosts === "true"
                              ? `${saveFilledIcon}`
                              : `${saveIcon}`
                          }
                          width={10}
                          height={16}
                          style={{
                            filter: effectiveIsSaved
                              ? "brightness(0) invert(1)"
                              : "none",
                          }}
                        />
                      </SaveButton>
                    </Grid>
                  )}
                  {/* {!spontaneous && ( */}
                  <Grid item xs={12}>
                    <ActionButton
                      variant="outlined"
                      onClick={openDetailsDialog}
                      fullWidth
                    >
                      <TruncatedTypography>
                        {t("jobCard.buttons.seeMoreDetails")}
                      </TruncatedTypography>
                    </ActionButton>
                  </Grid>
                  {/* )} */}
                  <Grid item xs={12}>
                    <ActionButton
                      variant="outlined"
                      onClick={handleApply}
                      fullWidth
                    >
                      <img
                        src={job.scraped ? mail_logo : smart_logo}
                        width={16}
                        height={16}
                      />
                      <TruncatedTypography>
                        {/* {job.scraped */}
                        {/* ? t("jobCard.buttons.applyWithMail") */}
                        {/* :  */}
                        {t("jobCard.buttons.smartApply")}
                      </TruncatedTypography>
                    </ActionButton>
                  </Grid>
                </Grid>
              </>
            )}

            {/* On desktop view */}
            {!isMobile && (
              <Grid container spacing={2}>
                <Grid item xs={userId && user.role === "c" ? 10 : 12}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <ActionButton
                      variant="outlined"
                      onClick={openDetailsDialog}
                    >
                      <TruncatedTypography>
                        {t("jobCard.buttons.seeMoreDetails")}
                      </TruncatedTypography>
                    </ActionButton>
                    <ActionButton
                      variant="outlined"
                      onClick={handleApply}
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        backgroundColor: !job.scraped ? "#0017E7" : "#FFFFFF",
                        // boxShadow: !job.scraped ? `0px 0px 10px 1px ${colors.primary}` : 'none',
                        "&:hover": !job.scraped
                          ? {
                            backgroundColor: "#FFFFFF",
                            "& .star": {
                              backgroundColor: "#0017E7",
                            },
                            "& img": {
                              content: `url(${smart_logo})`,
                            },
                            "& .MuiTypography-root": {
                              color: "#0017E7",
                            },
                          }
                          : {},
                        "&::before": !job.scraped
                          ? {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "none",
                            zIndex: 1,
                          }
                          : {},
                        "& .star": !job.scraped
                          ? {
                            position: "absolute",
                            width: "8px",
                            height: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            clipPath:
                              "polygon(50% 0%, 75% 38%, 100% 50%, 75% 62%, 50% 100%, 25% 62%, 0% 50%, 25% 38%)",
                            animation: "starShine 3s infinite ease-in-out",
                            "&:nth-of-type(1)": {
                              top: "15%",
                              left: "40%",
                              width: "5px",
                              height: "5px",
                            },
                            "&:nth-of-type(2)": {
                              top: "12%",
                              right: "7%",
                              width: "10px",
                              height: "10px",
                              animationDelay: "0.5s",
                            },
                            "&:nth-of-type(3)": {
                              bottom: "15%",
                              left: "64%",
                              width: "6px",
                              height: "6px",
                              animationDelay: "1s",
                            },
                          }
                          : {},
                        "@keyframes starShine": {
                          "0%, 100%": {
                            opacity: 0.5,
                            transform: "scale(1)",
                          },
                          "50%": {
                            opacity: 1,
                            transform: "scale(1.2)",
                          },
                        },
                        "& img, & .MuiTypography-root": {
                          position: "relative",
                          zIndex: 3,
                          color: !job.scraped ? "#FFFFFF" : "#0017E7",
                          transition: "all 0.3s ease",
                        },
                      }}
                    >
                      {!job.scraped && (
                        <>
                          <div className="star" />
                          <div className="star" />
                          <div className="star" />
                        </>
                      )}
                      <img
                        src={job.scraped ? mail_logo : smart_logo_white}
                        width={16}
                        height={16}
                      />
                      <TruncatedTypography>
                        {/* {job.scraped
                          ? t("jobCard.buttons.applyWithMail") */}
                        {/* : */}
                        {t("jobCard.buttons.smartApply")}
                      </TruncatedTypography>
                    </ActionButton>
                    {userId && user.role === "c" && (
                      <Grid item xs={2}>
                        <SaveButton
                          variant="outlined"
                          issaved={effectiveIsSaved ? "true" : "false"}
                          onClick={toggleSaveStatus}
                          fromSavedPosts={fromSavedPosts}
                        >
                          <img
                            src={
                              effectiveIsSaved ||
                                fromSavedPosts === true ||
                                fromSavedPosts === "true"
                                ? `${saveFilledIcon}`
                                : `${saveIcon}`
                            }
                            width={10}
                            height={16}
                            style={{
                              filter: effectiveIsSaved
                                ? "brightness(0) invert(1)"
                                : "none",
                            }}
                          />
                        </SaveButton>
                      </Grid>
                    )}
                  </Box>
                </Grid>
              </Grid>
            )}
          </Box>
          {/* </Grid> */}
        </CardContent>
      </JobCardContainer>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={snackbarState.action ? null : 3000}
        onClose={() => setSnackbarState((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: isMobile ? "center" : "center",
        }}
        sx={{
          bottom: isMobile ? "24px !important" : undefined,
          width: isMobile ? "90%" : undefined,
          left: isMobile ? "50% !important" : undefined,
          transform: isMobile ? "translateX(-50%) !important" : undefined,
        }}
      >
        <Alert
          severity={snackbarState.severity}
          action={snackbarState.action}
          sx={{
            width: "100%",
            fontSize: isMobile ? "12px" : undefined,
          }}
        >
          {snackbarState.message}
        </Alert>
      </Snackbar>
    </>
  );
}
